/**
 * OS web parity with the native OS app:
 *  - in-app account deletion request (public.account_deletion_requests, RLS: own row,
 *    app='os', platform='web'; 23505 = an open request already exists)
 *  - Google provider probe so a disabled Supabase provider never lands the user on
 *    Supabase's raw 400 JSON ("provider is not enabled")
 * Kept in sync with Bricks-Dispatch web/src/lib/web-account.ts.
 * Test: node --test src/lib/webAccount.test.js (from frontend/)
 */
const SUPPORT_EMAIL = "help@brxs.ca";
const DELETION_INFO_URL = "https://www.brxs.ca/account-deletion";
const GOOGLE_UNAVAILABLE_MESSAGE = "Google sign-in is not switched on for Bricks yet. Use email and password or a passkey.";
async function fetchOAuthProviderEnabled(provider, supabaseUrl, anonKey, fetchImpl = typeof fetch !== "undefined" ? fetch : null) {
  if (!supabaseUrl || !anonKey || !fetchImpl) return null;
  try {
    const res = await fetchImpl(`${supabaseUrl.replace(/\/$/, "")}/auth/v1/settings`, { headers: { apikey: anonKey } });
    if (!res || !res.ok) return null;
    const body = await res.json();
    if (!body || typeof body.external !== "object" || body.external === null) return null;
    return body.external[provider] === true;
  } catch {
    return null;
  }
}
function isProviderDisabledError(err) {
  const s = `${(err == null ? void 0 : err.code) || ""} ${(err == null ? void 0 : err.message) || ""}`.toLowerCase();
  return s.includes("provider is not enabled") || s.includes("unsupported provider");
}
function deletionMailto(email, userId, app = "os") {
  const subject = encodeURIComponent("Delete my Bricks account");
  const body = encodeURIComponent(
    `Please delete my Bricks account.

Account email: ${email || ""}
User ID: ${userId || ""}
App: ${app} (web)
`
  );
  return `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
}
async function requestAccountDeletion(client, user, reason) {
  var _a;
  if (!(user == null ? void 0 : user.id)) return { ok: false, error: "Sign in again to delete your account.", mailto: deletionMailto(null, null) };
  const mailto = deletionMailto(user.email, user.id);
  try {
    const { error } = await client.from("account_deletion_requests").insert({
      user_id: user.id,
      email: (_a = user.email) != null ? _a : null,
      app: "os",
      platform: "web",
      reason: (reason || "").trim().slice(0, 500) || null
    });
    if (!error) return { ok: true, via: "request" };
    if (error.code === "23505") return { ok: true, via: "request", already: true };
    return { ok: false, error: `Could not send the request (${error.message || error.code || "error"}). Email ${SUPPORT_EMAIL} from your account email instead.`, mailto };
  } catch {
    return { ok: false, error: `Could not reach Bricks. Email ${SUPPORT_EMAIL} from your account email instead.`, mailto };
  }
}
export {
  DELETION_INFO_URL,
  GOOGLE_UNAVAILABLE_MESSAGE,
  SUPPORT_EMAIL,
  deletionMailto,
  fetchOAuthProviderEnabled,
  isProviderDisabledError,
  requestAccountDeletion
};
